import React, { useEffect, useRef, useState } from "react";
import { ABtn, AResult, AScore } from "./arcadeUi";
import { sfx } from "@/lib/soundfx";

const TOTAL = 5;

// Gitte: toss the jack, tap the ground stones while it's airborne, then CATCH before it lands.
export default function Gitte() {
  const [remaining, setRemaining] = useState(TOTAL);
  const [collected, setCollected] = useState(0);
  const [lives, setLives] = useState(3);
  const [phase, setPhase] = useState("ready"); // ready | air | caught | won | over
  const [picked, setPicked] = useState(0);
  const [msg, setMsg] = useState(null);
  const land = useRef(null);
  const airtime = useRef(1500);

  const toss = () => {
    if (phase !== "ready" && phase !== "caught") return;
    setPicked(0); setMsg(null); setPhase("air");
    airtime.current = Math.max(850, 1500 - collected * 110);
    clearTimeout(land.current);
    land.current = setTimeout(dropped, airtime.current);
  };

  const pick = () => {
    if (phase !== "air") return;
    setPicked((p) => (p < remaining ? p + 1 : p));
    sfx.click?.();
  };

  const grab = () => {
    if (phase !== "air") return;
    clearTimeout(land.current);
    const got = picked;
    sfx.hit?.();
    setCollected((c) => c + got);
    setRemaining((r) => {
      const nr = r - got;
      if (nr <= 0) { setPhase("won"); setMsg("All gitte collected — full haath! 🏆"); }
      else { setPhase("caught"); setMsg(got ? `Picked ${got} & caught it! 👏` : "Caught it — but pick some next time!"); }
      return nr;
    });
    setPicked(0);
  };

  const dropped = () => {
    setPicked(0);
    setLives((l) => {
      const nl = l - 1;
      if (nl <= 0) { setPhase("over"); setMsg("Gitta gir gaya! Out. 😅"); }
      else { setPhase("caught"); setMsg("Missed the catch! ❌"); }
      return nl;
    });
  };

  const restart = () => { setRemaining(TOTAL); setCollected(0); setLives(3); setPicked(0); setPhase("ready"); setMsg(null); };
  useEffect(() => () => clearTimeout(land.current), []);

  return (
    <div className="w-full text-center">
      <div className="flex justify-center gap-2">
        <AScore label="Collected" value={`${collected}/${TOTAL}`} />
        <AScore label="Lives" value={"❤".repeat(Math.max(0, lives)) || "—"} />
      </div>
      <p className="my-3 text-sm text-kirana-brown/70">Toss the gitta, tap the ground stones while it's in the air, then CATCH before it lands!</p>

      <div data-testid="gitte-scene" className="relative mx-auto mb-3 h-44 w-full max-w-md overflow-hidden rounded-md border-2 border-kirana-border bg-gradient-to-b from-[#f6ead0] to-[#d9c39a]">
        {/* jack stone */}
        <div key={phase === "air" ? "up" : "down"} className={`absolute left-1/2 h-5 w-5 -translate-x-1/2 rounded-full bg-[#c94b31] border-2 border-[#7a5230] ${phase === "air" ? "gitte-toss" : ""}`}
          style={{ top: phase === "air" ? "8%" : "16%", animationDuration: `${airtime.current}ms` }} data-testid="gitte-jack" />
        {/* ground stones */}
        <div className="absolute bottom-4 left-1/2 flex -translate-x-1/2 gap-3">
          {Array.from({ length: remaining }).map((_, i) => (
            <button key={i} data-testid={`gitte-stone-${i}`} onClick={pick}
              className={`h-7 w-9 rounded-[50%] border-2 border-[#3a2617] transition-transform ${i < picked ? "scale-90 bg-kirana-green" : "bg-[#8a7a5a] hover:scale-110"}`} />
          ))}
        </div>
        {phase === "air" && <span className="absolute right-2 top-2 font-signboard text-xs font-bold text-kirana-red animate-pulse">Pick & catch!</span>}
      </div>

      <div className="mt-3 flex flex-wrap justify-center gap-2">
        {(phase === "ready" || phase === "caught") && <ABtn data-testid="gitte-toss" onClick={toss} tone="gold" className="px-8 py-3">Toss Gitta ⬆️</ABtn>}
        {phase === "air" && <ABtn data-testid="gitte-catch" onClick={grab} tone="red" className="px-12 py-3 text-lg">CATCH! ✋</ABtn>}
        {(phase === "won" || phase === "over") && (
          <div className="w-full">
            <AResult testId="gitte-result" win={phase === "won"} text={msg} />
            <div className="mt-3 flex justify-center"><ABtn data-testid="gitte-again" onClick={restart} tone="green">Play Again</ABtn></div>
          </div>
        )}
      </div>
      {(phase === "caught") && msg && <p className="mt-2 text-sm font-bold text-kirana-brown">{msg}</p>}
    </div>
  );
}
